import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { BehaviorSubject, Observable, finalize } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestsCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requestsCount++;
    this.loadingSubject.next(true);

    return next.handle(req).pipe(
      finalize(() => {
        this.requestsCount--;
        if (this.requestsCount === 0) {
          this.loadingSubject.next(false);
        }
      })
    );
  }

  isLoading(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }
}
